import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Check = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="check icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 6V18H21V6H3ZM2 3C0.895431 3 0 3.89543 0 5V19C0 20.1046 0.89543 21 2 21H22C23.1046 21 24 20.1046 24 19V5C24 3.89543 23.1046 3 22 3H2Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10C5 9.44772 5.44772 9 6 9H18C18.5523 9 19 9.44772 19 10C19 10.5523 18.5523 11 18 11H6C5.44772 11 5 10.5523 5 10Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 14C11 13.4477 11.4477 13 12 13H14C14.5523 13 15 13.4477 15 14C15 14.5523 14.5523 15 14 15H12C11.4477 15 11 14.5523 11 14Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 14C5 13.4477 5.44772 13 6 13H8C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15H6C5.44772 15 5 14.5523 5 14Z"
    />
  </svg>
)
